import React, { memo } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
const LandingLayout = dynamic(() => import('@/components/landing/home/LandingLayout'), { ssr: false });
const SEO = dynamic(() => import('@/components/landing/seo'), { ssr: false });
const NoteCourseLanding = dynamic(() => import('@/components/landing/notes/course'));

const Notes = () => {
  return (
    <>
      <Head>
        <title>Notes | Learnsic</title>
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SITE_URL}notes`} />
      </Head>
      <SEO
        meta_title={'Notes | Learnsic'}
        meta_description={'Learnsic notes'}
        meta_keywords={'Learnsic notes, Notes in Nepal, Online notes in Nepal'}
        photo={''}
        canonical="notes"
      />
      <LandingLayout>
        <NoteCourseLanding />
      </LandingLayout>
    </>
  );
};

export default memo(Notes);
